import { render } from "./defaultTable.vue?vue&type=template&id=e019a8fa"
import script from "./defaultTable.vue?vue&type=script&lang=js"
export * from "./defaultTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__